// extracted by mini-css-extract-plugin
export var button = "_b1-4";
export var hasDarkBackground = "_b1-7";
export var hasLightBackground = "_b1-6";
export var iconWrapper = "_b1-0";
export var large = "_b1-2";
export var medium = "_b1-1";
export var small = "_b1-5";
export var xsmall = "_b1-3";